import { createContext } from 'react';

const LottoAssistantActionsContext = createContext({
  sendTextMessage: async () => {},
  appendMessage: () => {},
  removeBetTicketById: () => {},
  removeMessageById: () => {},
  trackLottoEvent: () => {},
  setFlyingTicketSource: () => {},
});

export default LottoAssistantActionsContext;
